import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { EXPERTISE } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function ExpertiseGrid() {
  return (
    <section data-testid="expertise-section" className="bg-taupe py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <SectionHeading
          eyebrow="Different Crafts, One Destination"
          title="Your Idea. Our Craft."
          script="Details That Define Luxury"
          description="From statement walls to heirloom furniture — every discipline of architectural stone, under one roof in Udaipur."
        />
        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {EXPERTISE.map((e, i) => (
            <Reveal key={e.slug} delay={(i % 3) * 0.1}>
              <Link
                to={`/expertise#${e.slug}`}
                data-testid={`expertise-card-${e.slug}`}
                className="group relative block overflow-hidden rounded-xl spotlight-frame"
              >
                <img
                  src={e.image}
                  alt={e.title}
                  loading="lazy"
                  className={`aspect-[4/3] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${e.pos || "object-center"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-5">
                  <div>
                    <span className="font-display text-[10px] tracking-[0.3em] text-gold-soft">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="mt-1 font-serif text-xl font-medium text-stone-100 transition-colors group-hover:text-gold-glow">
                      {e.title}
                    </h3>
                  </div>
                  <span className="rounded-full border border-gold/40 bg-obsidian/50 p-2 text-gold opacity-0 backdrop-blur-sm transition-all duration-300 group-hover:opacity-100">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
          <Reveal delay={0.2}>
            <Link
              to="/expertise"
              data-testid="expertise-view-all"
              className="group flex h-full min-h-[200px] flex-col items-start justify-between rounded-xl border border-gold/30 bg-obsidian p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_35px_rgba(212,175,55,0.2)]"
            >
              <p className="font-serif text-2xl italic text-stone-200">
                Explore every craft in detail
              </p>
              <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-gold">
                View Expertise
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
